import React from 'react';
import { usePortfolio } from '../hooks/usePortfolio';
import { useSiteConfig } from '../hooks/useSiteConfig';
import Editable from '../components/Editable';
import './Pages.css';

const categories = [
  {
    id: 1,
    key: 'woodwork',
    title: 'Custom Woodwork',
    description: 'Cutting boards, planters, trellises, clocks, baskets, signs, and other unique wood pieces.',
    photos: [
      '/portfolio/woodwork/woodwork-1.png',
      '/portfolio/woodwork/woodwork-2.png',
      '/portfolio/woodwork/woodwork-3.png',
      '/portfolio/woodwork/woodwork-4.jpeg',
      '/portfolio/woodwork/woodwork-5.jpeg',
      '/portfolio/woodwork/woodwork-6.jpeg',
    ],
  },
  {
    id: 2,
    key: 'laser-engraved',
    title: 'Laser-Engraved Items',
    description: 'Personalized designs on wood, gifts, décor, and keepsakes.',
    photos: [
      '/portfolio/laser-engraved/laser-1.jpeg',
      '/portfolio/laser-engraved/laser-2.jpeg',
      '/portfolio/laser-engraved/laser-3.jpeg',
      '/portfolio/laser-engraved/laser-4.jpeg',
    ],
  },
  {
    id: 3,
    key: 'greeting-cards',
    title: 'Handmade Greeting Cards',
    description: 'Custom cards for birthdays, holidays, and special occasions.',
    photos: [
      '/portfolio/greeting-cards/card-1.jpeg',
      '/portfolio/greeting-cards/card-2.png',
      '/portfolio/greeting-cards/card-3.jpeg',
      '/portfolio/greeting-cards/card-4.jpeg',
      '/portfolio/greeting-cards/card-5.jpeg',
      '/portfolio/greeting-cards/card-6.png',
      '/portfolio/greeting-cards/card-7.jpeg',
      '/portfolio/greeting-cards/card-8.jpeg',
    ],
  },
  {
    id: 4,
    key: 'jewelry-gifts',
    title: 'Jewelry & Small Gifts',
    description: 'Wooden jewelry, magnets, and other handcrafted keepsakes.',
    photos: [
      '/portfolio/jewelry-gifts/jewelry-1.jpeg',
      '/portfolio/jewelry-gifts/jewelry-2.jpeg',
      '/portfolio/jewelry-gifts/jewelry-3.jpeg',
    ],
  },
  {
    id: 5,
    key: 'soaps-wax',
    title: 'Soaps & Scented Wax Melts',
    description: 'Handmade cold-process soaps and fragrant wax melts for personal use or gifts.',
    photos: [],
  },
  {
    id: 6,
    key: 'home-decor',
    title: 'Personalized Home Décor',
    description: 'Custom signs, décor items, and functional pieces that add charm to any space.',
    photos: [],
  },
];

export { categories as PORTFOLIO_CATEGORIES };

export default function Portfolio() {
  const { items } = usePortfolio();
  const { config } = useSiteConfig();
  const meta = (config && config.portfolio_meta) || {};

  // After Initialize DB, every built-in photo is imported as a real portfolio
  // row, so DB items become the source of truth. Fall back to the hard-coded
  // built-ins only when the DB has no items at all (pre-init state), so the
  // site keeps rendering unchanged.
  const dbInitialised = Array.isArray(items) && items.length > 0;
  const merged = categories.map((cat) => {
    const m = meta[cat.key] || {};
    const dbForCat = dbInitialised
      ? (items || []).filter((it) => it.category === cat.key).map((it) => it.image_url)
      : null;
    const photos = dbInitialised ? dbForCat : cat.photos;
    return {
      ...cat,
      title: m.title || cat.title,
      description: m.description || cat.description,
      photos,
    };
  });

  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>Our Portfolio</h1>
          <p>Handcrafted with care — browse our collection by category</p>
        </div>
      </section>

      {merged.map((cat, index) => (
        <Editable
          key={cat.id}
          descriptor={{ kind: 'portfolio_category', key: cat.key, label: `${cat.title} photos` }}
        >
          <section
            className={`portfolio-category-section ${index % 2 === 1 ? 'portfolio-category-alt' : ''}`}
          >
            <div className="container">
              <div className="portfolio-category-header">
                <h2>{cat.title}</h2>
                <p>{cat.description}</p>
              </div>
              {cat.photos.length > 0 ? (
                <div className="portfolio-photo-grid">
                  {cat.photos.map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      alt={`${cat.title} ${i + 1}`}
                      className="portfolio-photo"
                    />
                  ))}
                </div>
              ) : (
                <p className="portfolio-coming-soon">Photos coming soon.</p>
              )}
            </div>
          </section>
        </Editable>
      ))}
    </main>
  );
}
